import { createContext, useContext } from 'react';
import { CareType } from '../../graphQL';

/**
 * Note-level metadata that deeply-nested question components need but that
 * isn't part of the react-hook-form values (e.g. the note's care type, used to
 * scope the appointment selector). Provided once at the note root so individual
 * questions can read it without prop drilling through every Question/FormElement.
 */
type NoteContextValue = {
  careType?: CareType | null;
};

const NoteContext = createContext<NoteContextValue>({});

export const NoteContextProvider = NoteContext.Provider;

export const useNoteContext = () => useContext(NoteContext);
